// extracted by mini-css-extract-plugin
module.exports = {"table":"Matrix_table__3J6uu","cell":"Matrix_cell__1nE0j"};